export function observeElementIntersect(elements, callback, options = {}) {
    if (!elements.length) {
        return;
    }
    let elementObserver;
    const observeHandler = (entries) => {
        if (!entries.length) {
            elementObserver.disconnect();
        }
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                callback(entry.target);
                elementObserver.unobserve(entry.target);
            }
        });
    };
    if ('IntersectionObserver' in window) {
        elementObserver = new IntersectionObserver(observeHandler, options);
        elements.forEach((element) => {
            elementObserver.observe(element);
        });
    }
}
